export default "__VITE_ASSET__cWixHqGs__"